import { useTranslation } from "react-i18next";
import * as Yup from "yup";

const MsisdnValidation = () => {
    const {t} = useTranslation();
    return Yup.string().required(t("field_required", {field: t("Mobile Number")})).test("check-validation", t("field_invalid", {field: t("Mobile Number")}), function(value){
        const code = this.parent.msisdn_code;
        if(!code || code.code !== "+98")
            return (value.length >= 7 && value.length <= 11);
        if(value.startsWith("0")) return false;
        if(!value.startsWith("9")) return false;
        return (value.length === 10);
    });
}
const EmailValidation = () => {
    const {t} = useTranslation();
    return Yup.string().email(t("field_invalid", {field: t("E-Mail")})).required(t("field_required", {field: t("E-Mail")}));
}
const EmptyValidation = (field) => {
    const {t} = useTranslation();
    return Yup.string().required(t("field_required", {field}));
}
const PasswordValidation = () => {
    const {t} = useTranslation();
    return {
        password: Yup.string().required(t("field_required", {field: t("Password")})),
        password_confirmation: Yup.string().oneOf([Yup.ref('password')], t("Passwords do not match.")).required(t("field_required", {field: t("Confirm password")}))
    };
}
const DateOfBirthValidation = () => {
    const {t} = useTranslation();
    return Yup.mixed()
        .required(t("field_required", {field: t("Date of Birth")}))
        .test("is-date", t("field_invalid", {field: t("Date of Birth")}), (date) => {
            return date instanceof Date && !isNaN(date);
        })
        .test("not-too-old", t("You must be over {{year}} years old.", {year: 15}), (date) => {
            if (!(date instanceof Date)) return false;
            const today = new Date();
            const minDate = new Date(today.getFullYear() - 15, today.getMonth(), today.getDate());
            return date <= minDate;
        });
}

const YupValidation = {
    MsisdnValidation,
    EmailValidation,
    PasswordValidation,
    DateOfBirthValidation,
    EmptyValidation
};

export default YupValidation;